import React from 'react';
export function SectionDivider() {
  return <div className="w-full flex justify-center py-8 md:py-12 reveal" data-id="element-604">
      <div className="h-[1px] w-3/5 bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" data-id="element-605" />
    </div>;
}